import HTTPClient from 'utils/HTTPClient';

export function getEnrollMobileconfig(): Promise<string> {
  return HTTPClient.get('/mdm/enroll').then((data) => data.data);
}

export function sendManagerAppProfile({ studentId }: { studentId: number }): Promise<void> {
  return HTTPClient.post(`/mdm/managed-app-profile/${studentId}`);
}
